import { useI18n } from 'vue-i18n'

export const useIntegrationPage = () => {
    const { t, tm } = useI18n()

    const TRANSLATE_INSTRUCTION_TEMPLATE_PATH = "page.instruction_template.list"
    const commonKeys = ["text1", "text3", "text4"]

    const getMessengerKey = (messengers) => {
        return [...messengers].sort().join('_')
    }

    const getInstructionTexts = (messengers, CRM) => {
        const messengerKey = getMessengerKey(messengers)

        const commonTexts = commonKeys.map(key =>
            t(`${TRANSLATE_INSTRUCTION_TEMPLATE_PATH}.common.${key}`, { crm: CRM })
        )

        const messengerText = t(
            `${TRANSLATE_INSTRUCTION_TEMPLATE_PATH}.byMessengers.${messengerKey}`
        )

        return [...commonTexts, messengerText]
    }

    return {
        getInstructionTexts
    }
}
